import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { getProductByCategory, getProductBySku, getProductBysubCategory } from '../grapql/products';
import { mappingProductsByCategory } from '../utils/mappingProducts';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private url = environment.api;

  constructor(private http: HttpClient) { }

  getProductByMainCategories(catalog: string = ''): Observable<any> {
    return this.http.post<any>(`${this.url}`, {query: getProductByCategory(catalog)}).pipe(
      map((res: any) => {
        return mappingProductsByCategory(res.data.categoriaPrincipals);
      })
    );
  }
  getProductBysubCategories(catalog: string = ''): Observable<any> {
    return this.http.post<any>(`${this.url}`, {query: getProductBysubCategory(catalog)}).pipe(
      map((res: any) => {
        return (res.data.categoria.producto);
      })
    );
  }
  getProductBySku(sku:string):Observable<any> {
    return this.http.post<any>(`${this.url}`, {query: getProductBySku(sku)}).pipe(
      map((res: any) => res.data.producto)
    );
  }
}
